import React from 'react';
import { Flex } from '../../../layout';
import { block } from '../../../utils/cn';
import './ListContainerView.css';
const b = block('list-container-view');
export const ListContainerView = React.forwardRef(function ListContainerView({ as = 'div', role = 'listbox', children, id, className, fixedHeight, extraProps }, ref) {
    return (React.createElement(Flex, Object.assign({ as: as, direction: "column", ref: ref, grow: true, tabIndex: -1, id: id, role: role, className: b({ 'fixed-height': fixedHeight }, className) }, extraProps), children));
});
